import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDL1Bz6mY-Vh-0SKFHTaa3CcgXeBVRccEg",
  authDomain: "dixon-app-development-7f919.firebaseapp.com",
  projectId: "dixon-app-development-7f919",
  storageBucket: "dixon-app-development-7f919.firebasestorage.app",
  messagingSenderId: "771109080478",
  appId: "1:771109080478:web:6d3937dad0237ef77d1a8f",
  measurementId: "G-BYJTV67JWK",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics (only in browser)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Initialize Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
